import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

const COMPETITIONS = "competitions";

function metaRef(competitionId) {
  return doc(db, COMPETITIONS, competitionId, "meta", "meta");
}

/** @type {import('./competitionRepository.interface').CompetitionRepository} */
export const firestoreCompetitionRepository = {
  async getMeta(competitionId) {
    const snap = await getDoc(metaRef(competitionId));
    return snap.exists() ? /** @type {import('../../domain/cmoe/competition/competitionTypes').CompetitionMeta} */ (snap.data()) : null;
  },
  async saveMeta(meta) {
    await setDoc(metaRef(meta.competitionId), meta, { merge: true });
  },
  async findByExternalRef(refKey, refValue) {
    // Phase 1: index by roomCode on matches shell; full scan deferred until CMOE migration phase
    void refKey;
    void refValue;
    return null;
  },
};
